<template>
  <div class="materials-page__tags" ref="container" :class="{ _test: isTest, _show: isShowMore }">
    <div class="materials-page__tags-inner">
      <router-link-modified :to="{query: {tags: []}}"
                            ref="tagsReset"
                            v-if="isTest || hasSelectedTags"
                            class="materials-page__tags-item tag-btn _orange">
        <span class="tag-btn__text">{{ $tAccount('Reset all') }}</span>
        <BaseSvg class="tag-btn__ico-close"
                 name="ico-close"/>
      </router-link-modified>

      <router-link-modified v-for="item in tagsToShow"
                            :to="getRoute(item.slug)"
                            :key="item.id"
                            ref="tags"
                            :class="getActiveClass(item.slug)"
                            class="materials-page__tags-item tag-btn _border">
        <span class="tag-btn__text">{{ item.name }} ({{ item.use_count }})</span>
      </router-link-modified>

      <template v-if="isShowMore">
        <router-link-modified v-for="item in tagsToHide"
                              :to="getRoute(item.slug)"
                              :key="item.id"
                              class="materials-page__tags-item tag-btn _border">
          <span class="tag-btn__text">{{ item.name }} ({{ item.use_count }})</span>
        </router-link-modified>
      </template>

      <button type="button"
              ref="more"
              v-if="tagsToHide.length"
              @click.prevent="isShowMore = !isShowMore"
              class="materials-page__tags-more">
        <span v-if="!isShowMore">{{ $tAccount('More') }}</span>
        <span v-else>{{ $tAccount('Less') }}</span>
        <BaseSvg name="ico-arrow-down"/>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MaterialTags',
    props: {
      tagsList: Array
    },
    data() {
      return {
        isTest: true,
        timer: null,
        isShowMore: false,
        sliceIndex: 1000
      }
    },
    computed: {
      tagsToShow() {
        return this.tagsList.slice(0, this.sliceIndex)
      },
      tagsToHide() {
        return this.tagsList.slice(this.sliceIndex, 1000)
      },
      hasSelectedTags() {
        let tags = this.$route.query.tags
        return !!(tags && tags.length)
      }
    },
    methods: {
      checkTagsToShow() {
        if (this.isShowMore) return
        this.isTest = true
        this.sliceIndex = 100
        let heightItems = 2

        if (window.innerWidth < 768) {
          heightItems = 3
        }

        setTimeout(() => {
          let tagsReset = this.$refs.tagsReset
          let tags = this.$refs.tags
          let container = this.$refs.container

          if(!Array.isArray(tags) || !tags.length) return
          tags = tags.concat(tagsReset)

          if (container.scrollWidth > container.offsetWidth) {
            const containerTop = container.getBoundingClientRect().top
            const elHeight = tags[0].offsetHeight + 13
            const bottomBorder = containerTop + elHeight * heightItems

            const index = tags.findIndex((item) => {
              item = item.$el || item
              return item.getBoundingClientRect().top > bottomBorder
            })

            if (index > -1 && typeof index === 'number') {
              this.sliceIndex = index - 1
            } else {
              this.sliceIndex = 1000
            }
          }

          this.isTest = false
        }, 50)
      },
      check() {
        clearTimeout(this.timer)
        this.timer = setTimeout(this.checkTagsToShow, 200)
      },
      getRoute(slug) {
        let tags = this.$route.query.tags

        if (!Array.isArray(tags)) {
          tags = []
        } else {
          tags = [...tags]
        }

        const index = tags.indexOf(slug)

        if (index > -1) {
          tags.splice(index, 1)
        } else {
          tags.push(slug)
        }

        return {
          query: {
            tags
          }
        }
      },
      getActiveClass(slug) {
        let tags = this.$route.query.tags

        if(tags && !Array.isArray(tags)) {
          tags = [tags]
        }

        if (Array.isArray(tags) && tags.includes(slug)) {
          return '_active'
        }
      }
    },
    mounted() {
      this.checkTagsToShow()
      window.addEventListener('resize', this.check)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.check)
    }
  }
</script>

<style>

</style>
